import styled from "@emotion/styled";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";

interface Props {
	className?: string;
	title?: string;
	subTitle?: string;
	description?: string;
	img: string;
	linkTitle?: string;
	url?: string;
}

export const BigImgCard = (props: Props) => {
	const navigate = useNavigate();

	return (
		<Container className={props.className} onClick={() => props.url && navigate(props.url)}>
			<div className='image'>
				{(props.title || props.subTitle) && (
					<div className='position'>
						{props.title && <h2 className='i-top'>{props.title}</h2>}
						{props.subTitle && <h3 className='i-sub'>{props.subTitle ?? ""}</h3>}
					</div>
				)}
				<Image src={props.img} preview={false} width='100%' />
			</div>
			{props.description && <div className='i-description' dangerouslySetInnerHTML={{ __html: props.description ?? "" }} />}
		</Container>
	);
};
const Container = styled.div`
	margin-top: 15px;
	cursor: pointer;

	.image {
		position: relative;

		.position {
			position: absolute;
			z-index: 10;
			color: white;
			padding-left: 1rem;
			.i-top {
				width: 100%;
				padding: 3rem 0.5rem 0.5rem;
				font-weight: 500;
				margin-bottom: 0.5rem;
				color: white;
			}

			.i-sub {
				font-size: 14px;
				margin-bottom: 0.5rem;
				min-height: 50px;
				color: white;
			}
		}
	}

	.i-description {
		background: #004885;
		color: white;
		padding: .5rem;
	}
`;
